module.exports = __webpack_public_path__ + "static/media/icon_sort_disabled.dd160eef.svg";